'use client';

import Script from 'next/script';

// ----------------------------------------------------------------------

/**
 * Komponent inicjalizujący Google Consent Mode v2
 * Musi być załadowany przed Google Analytics
 */
export default function GoogleConsentInit() {
  return (
    <Script
      id="google-consent-init"
      strategy="beforeInteractive"
      dangerouslySetInnerHTML={{
        __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}

          // Ustaw domyślne zgody na "denied"
          gtag('consent', 'default', {
            'analytics_storage': 'denied',
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'wait_for_update': 500
          });

          // Sprawdź czy użytkownik wcześniej wyraził zgodę
          var savedConsent = localStorage.getItem('cookieConsent');
          if (savedConsent === 'true') {
            gtag('consent', 'update', {
              'analytics_storage': 'granted'
            });
          }
        `,
      }}
    />
  );
}

